module.exports = __webpack_public_path__ + "img/horizontal_6_6_0.4d44d424.png";